import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as moment from 'moment';
import {
    IOfferTemplate,
    IOfferType,
    ISpecialOffer,
    OfferTemplateTypeEnum,
    SpecialOfferTypeEnum
} from '../../../models';
import { OffersService } from '../../../services/offers.service';

class ProductSpecialOffer implements ng.IController {
    public static inject = ['$translate', 'offerService'];

    public specialOffer: ISpecialOffer;
    public oldPrice: number;
    public currencyClass: string;
    public isReadOnly: boolean;
    public isDisabled: boolean;
    public variationId: string;
    public onSpecialOfferChanged: (message: any) => any;

    public SpecialOfferTypeEnum = SpecialOfferTypeEnum;
    public isEndDateExpired: boolean = false;
    public switchSpecialOffer: boolean;
    public expiredMessage: string = this.$translate.instant('the_offer_has_expired');
    public disabledMessage: string = this.$translate.instant('incompatible_with_staff_discount');
    public utcToday: Date = moment(new Date()).utc(true).startOf('day').toDate();

    public startDateOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        minDate: this.utcToday
    };
    public endDateOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        minDate: moment(this.utcToday).add(1, 'days').toDate() as Date
    };
    public offerTypes: IOfferType[];
    public selectedType: IOfferType;
    public selectedTemplate: IOfferTemplate;

    constructor(
        protected $translate: angular.translate.ITranslateService,
        protected offersService: OffersService
    ) {
        this.offerTypes = this.offersService.getOfferTypes();
    }

    public $onInit() {
        this.setState();
    }

    public $onChanges(onChangesObj: angular.IOnChangesObject): void {
        this.setState();
    }

    public setState() {
        if (this.specialOffer) {
            this.switchSpecialOffer = this.specialOffer.Type !== SpecialOfferTypeEnum.None;
            this.selectedType = this.offerTypes.find((type) => type.value === this.specialOffer.Type);
            if (this.selectedType && this.selectedType.templates) {
                if (!this.specialOffer.TemplateType) {
                    this.specialOffer.TemplateType = this.selectedType.templates[0].value;
                }
                this.selectedTemplate = this.selectedType.templates.find((item) => item.value === this.specialOffer.TemplateType);
            }
            this.isEndDateExpired = moment.utc(this.utcToday).isAfter(moment.utc(this.specialOffer.OfferValidTo), 'date');
            this.specialOffer.error = {};
        }
    }

    public offerSwitchChanged() {
        if (this.switchSpecialOffer) {
            this.selectedType = this.offerTypes[0];
            this.selectedTemplate = this.selectedType.templates[0];
            this.specialOffer = {
                Type: this.selectedType.value,
                TemplateType: this.selectedTemplate.value,
                OfferValidFrom: this.utcToday,
                OfferValidTo: moment(this.utcToday).add(1, 'days').toDate() as Date,
                BuyXGetYOfferValues: {},
                BuyXForYSumYOfferValues: {},
                error: {}
            } as ISpecialOffer;
        } else {
            this.specialOffer = null;
        }
        const message = {
            variationID: this.variationId,
            badgeValue: this.specialOffer !== null
        };
        this.onSpecialOfferChanged({specialOfferMessage: message});
    }

    public offerTypeChanged() {
        this.specialOffer.Type = this.selectedType.value;
        this.selectedTemplate = this.selectedType.templates ? this.selectedType.templates[0] : null;
        this.specialOffer.TemplateType = this.selectedTemplate ? this.selectedTemplate.value : OfferTemplateTypeEnum.None;
        this.specialOffer.DiscountPrice = this.selectedType.value === SpecialOfferTypeEnum.Discount ? null : 0;
        this.specialOffer.BuyXGetYOfferValues = {};
        this.specialOffer.BuyXForYSumYOfferValues = {};
        this.specialOffer.error = {};
    }

    public offerTemplateChanged() {
        this.specialOffer.TemplateType = this.selectedTemplate.value;
    }

    public onStartDateChanged() {
        this.endDateOptions.minDate = moment(this.specialOffer.OfferValidFrom).add(1, 'days').toDate() as Date;
    }

    public onEndDateChanged() {
        this.isEndDateExpired = moment(this.utcToday).isAfter(this.specialOffer.OfferValidTo, 'date');
    }
}

angular.module('naut').component('productSpecialOffer', {
    template: require('./product-special-offer.component.html'),
    controller: ProductSpecialOffer,
    controllerAs: 'ctrl',
    bindings: {
        specialOffer: '=',
        oldPrice: '<',
        currencyClass: '<',
        isDisabled: '<',
        isReadOnly: '<',
        variationId: '<',
        onSpecialOfferChanged: '&'
    }
});



// WEBPACK FOOTER //
// ./src/app.retailer/modules/products/components/shared/product-special-offer/product-special-offer.component.ts